var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoCircleIcon, Menu, MenuItem, translate, useModal, } from '@lucidlink/uicore';
import { MODAL_IDS } from '@lucidlink/workspacemanagement';
import { FilespaceMenuTestIdFactory } from '@lucidlink/workspacemanagement/interactions';
import { FilespaceDetailsWebModal } from '../modals';
import { FilespaceMenuItems } from './FilespaceMenuItems';
export const FilespaceMenu = ({ filespace, onMenuClick, }) => {
    _react_refresh_temp_2();
    const { closeModal: closeFilespaceDetailsModal, openModal: openFilespaceDetailsModal, } = useModal({ modalId: MODAL_IDS.FilespaceDetails });
    return (_jsxs(Menu, { navigationType: "arrows", children: [_jsx(FilespaceMenuItems, { filespace: filespace, onMenuClick: onMenuClick }), _jsx(MenuItem, { "data-testid": FilespaceMenuTestIdFactory.getFilespaceDetailsMenuItemTestId(), LeadingIcon: InfoCircleIcon, onClick: () => {
                    openFilespaceDetailsModal({
                        content: (_jsx(FilespaceDetailsWebModal, { closeModal: closeFilespaceDetailsModal, filespace: filespace })),
                    });
                    if (onMenuClick) {
                        onMenuClick();
                    }
                }, text: translate('Filespace details') })] }));
};
_react_refresh_temp_1 = FilespaceMenu;
$RefreshReg$(_react_refresh_temp_1, "FilespaceMenu");
_react_refresh_temp_2(FilespaceMenu, "jBn2XeOk6Qq5xb5qhQ3BurXhVbY=", false, () => [useModal]);
